import React,{useState,FunctionComponent, useRef, useEffect } from 'react';
import {DropDownItem,NavbarDropdownContent,NavbarDropdown,SelectedDescription,SelectedIcon,SelectTitleContainer} from './style';
import {v4 as uuid} from 'uuid'
import {useOutsideAction} from './utils'
import { language } from '../../utils/language';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/reducers/index';

type CategoryProps =  {
    id: number
    name: string
}

type TypesProps = {
    items: CategoryProps[]
    onSelect: (item: string) => void
}


const Select:FunctionComponent<TypesProps> = ({items, onSelect}) => {
    const homeState: HomeStateType = useSelector((state: RootState) => state.home);
    
    const allCategoriesItem = {
        id: 0,
        name: language[homeState.default_language]["allCategory"]
      };
    
    const outstandingItem = {
        id: 1,
        name: language[homeState.default_language]["outstanding"]
      };

    const [isOpen,setIsOpen] = useState(false);
    const [selected,setSelected] = useState(allCategoriesItem);

    const componentRef = useRef<HTMLDivElement>(null)
    useOutsideAction(componentRef, setIsOpen)

    useEffect(() => {
        setSelected(allCategoriesItem);
      }
        , [homeState.default_language]);

    const handleToggle = ()=>{
        setIsOpen(!isOpen);
    }

    const handleItemSelected = (item:any)=>{
        setSelected(item);
        switch (item.id) {
            case 0:
                onSelect(allCategoriesItem.name);
                break;
            case 1:
                onSelect(outstandingItem.name);
                break;
            default:
                onSelect(item.id);
                break;
        }
    }

    const closeDropDown = ()=>{
        setIsOpen(false);
    }

    return (
        <NavbarDropdown 
            onBlur={()=>closeDropDown()} 
            onFocus={()=>closeDropDown()}
            open={isOpen} 
            onClick={()=>handleToggle()} 
            ref={componentRef}
        >
            <SelectTitleContainer>
                <SelectedDescription>
                    {selected.name}
                </SelectedDescription>
                <SelectedIcon open={isOpen}>
                    <svg width="15" height="15" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="6.82724" height="1.36545" rx="0.5" transform="matrix(-0.724999 0.68875 -0.724999 -0.68875 10.8633 5.55273)" fill="#999999"/>
                        <rect width="6.82724" height="1.36545" rx="0.5" transform="matrix(0.724999 0.68875 -0.724999 0.68875 1.9541 4.6123)" fill="#999999"/>
                    </svg>
                </SelectedIcon>
            </SelectTitleContainer>
            <NavbarDropdownContent open={isOpen}>
                <DropDownItem key={0} onClick={()=>handleItemSelected(allCategoriesItem)}>{allCategoriesItem.name}</DropDownItem>
                <DropDownItem key={1} onClick={()=>handleItemSelected(outstandingItem)}>{outstandingItem.name}</DropDownItem>
                {items.map((i:any)=>{
                    return <DropDownItem key={uuid()} onClick={()=>handleItemSelected(i)}>{i.name}</DropDownItem>
                }) }
            </NavbarDropdownContent>
        </NavbarDropdown>
    )}

export default Select